<template>
  <div class="maximized-video-panel" @mouseover="hoverVideo = true;" @mouseleave="hoverVideo = false">
    <md-button :md-ripple="false" class="md-icon-button enabelPointer active exit-button"
               @click="this.toggleMaximizedVideoPanel">
      <GridOff/>
    </md-button>

    <!-- streams of other users -->
    <div class="video-streams">
      <div class="stream-container">

        <div class="video-streams-column" v-for="(column, indexColumn) in streamGrid">
          <div  style="height: 100%; width: 100%; position: relative"
               v-for="(row, indexRow) in streamGrid[indexColumn]"
               >
              <div v-if="streamGrid[indexColumn][indexRow].connection"
                   @mouseenter="handleHoverOverStream(streamGrid[indexColumn][indexRow].connection.data.user_id, true)"
                   @mouseleave="handleHoverOverStream(streamGrid[indexColumn][indexRow].connection.data.user_id, false)"
                   class="stream-panel">
                <span v-if="streamGrid[indexColumn][indexRow]" class="badge-container">
              <img v-if="streamGrid[indexColumn][indexRow].hasVideo" class="badge small-badge"
                   :src="getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id).getUserIcon()"/>
              <div v-if="streamGrid[indexColumn][indexRow].hasVideo"
                   :id="createElementId('audio', streamGrid[indexColumn][indexRow].connection.data.user_id)"
                   class="badge audio-badge small-badge"
                   :style="{'background-color':getUserColor(getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id))}"/>
              <span v-if="isUserWithIDModerator(streamGrid[indexColumn][indexRow].connection.data.user_id)"
                    class="moderator-title">Moderator:</span>
              <span
                  class="user-name">{{ getUserName(streamGrid[indexColumn][indexRow].connection.data.user_id) }}</span>
            </span>
                <FluxComSubscriber :stream="streamGrid[indexColumn][indexRow]"
                                   :opts="publisherAndSubscriberProperties"></FluxComSubscriber>
                <div v-if="!streamGrid[indexColumn][indexRow].hasVideo">
                  <img class="badge central-badge normal-badge large-badge"
                       v-if="!getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id).getUserIcon()"
                       :src="getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id).getUserIcon()"/>
                  <div v-if="getUserColor(getUserOfId(getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id))) && getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id).getAcronym && !getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id).getUserIcon()"
                       class="badge central-badge audio-badge large-badge"
                       :style="{'background-color':getUserColor(getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id))}">
                    {{getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id).getAcronym}}
                  </div>
                  <div :id="createElementId('badge', streamGrid[indexColumn][indexRow].connection.data.user_id)"
                       class="badge central-badge audio-badge large-badge"
                       :style="{'background-color':getUserColor(getUserOfId(streamGrid[indexColumn][indexRow].connection.data.user_id))}"/>
                </div>

                <!-- Controls for streams -->
                <transition name="fade">
                  <div class="subscriber-control-bar-container" v-if="help && getHoverStateOfStream(streamGrid[indexColumn][indexRow].connection.data.user_id)">
                    <div class="volume-slider-container"
                         v-if="help && getHoverStateOfVolume(streamGrid[indexColumn][indexRow].connection.data.user_id)"
                         @mouseenter="handleHoverOverVolume(streamGrid[indexColumn][indexRow].connection.data.user_id, true)"
                         @mouseleave="handleHoverOverVolume(streamGrid[indexColumn][indexRow].connection.data.user_id, false)">
                      <input class="subscriber-volume-slider"
                             type="range"
                             :value="getVolumeOfSubscriber(streamGrid[indexColumn][indexRow].connection.data.user_id)"
                             @change="setVolumeOfSubscriber(streamGrid[indexColumn][indexRow].connection.data.user_id)"
                      >
                    </div>
                    <div class="control-bar subscriber-control-bar">
                      <div class="volume-container"
                           @mouseenter="handleHoverOverVolume(streamGrid[indexColumn][indexRow].connection.data.user_id, true)"
                           @mouseleave="handleHoverOverVolume(streamGrid[indexColumn][indexRow].connection.data.user_id, false)">
                        <md-button
                            v-if="help && getVolumeOfSubscriber(streamGrid[indexColumn][indexRow].connection.data.user_id) > 0"
                            @click="setVolumeOfSubscriber(streamGrid[indexColumn][indexRow].connection.data.user_id, 'mute')">
                          <VolumeHigh></VolumeHigh>
                        </md-button>
                        <md-button v-else
                                   @click="setVolumeOfSubscriber(streamGrid[indexColumn][indexRow].connection.data.user_id, 'unmute')">
                          <VolumeOff></VolumeOff>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>

            <div v-else style="height: 100%; width: 100%; position: relative">

              <!-- users that have neither audio nor video stream -->
                <div class="stream-panel" v-if="streamGrid[indexColumn][indexRow] && !Number(streamGrid[indexColumn][indexRow])">
                  <span class="name-badge">{{ streamGrid[indexColumn][indexRow].getName() }}</span>
                  <img class="badge central-badge normal-badge large-badge" v-if="streamGrid[indexColumn][indexRow].getUserIcon()" :src="streamGrid[indexColumn][indexRow].getUserIcon()"/>
                  <div v-if="getUserColor(getUserOfId(streamGrid[indexColumn][indexRow].id)) && streamGrid[indexColumn][indexRow].getAcronym && !streamGrid[indexColumn][indexRow].getUserIcon()"
                       class="badge central-badge audio-badge large-badge"
                       :style="{'background-color':getUserColor(getUserOfId(streamGrid[indexColumn][indexRow].id))}">
                    {{streamGrid[indexColumn][indexRow].getAcronym}}
                  </div>
                </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- Stream of local user -->
    <div v-if="this.localUser !== undefined" class="local-user-stream" @mouseenter="showControls = true"
         @mouseleave="showControls = false"
         :class="{ 'moderator': localUserIsModerator(), 'visitor': !localUserIsModerator() }">
      <div class="badge-container">
        <img v-if="publisher && properties.hasVideo && isVideoOn" class="badge small-badge"
             :src="localUser.getUserIcon()"/>
        <div v-if="publisher && properties.hasVideo && isVideoOn" id="local-user-small-audio-badge"
             class="badge audio-badge small-badge" :style="{'background-color':getUserColor(localUser)}"/>
        <span v-if="localUserIsModerator()" class="moderator-title">Moderator:</span>
        <span class="user-name">{{ localUserName }}</span>
      </div>
      <FluxComPublisher id="publisher-container" where="maximized-video-panel"
                        :opts="publisherAndSubscriberProperties"/>
      <div v-if="!properties.hasVideo || !publisher || !isVideoOn">
        <img class="badge central-badge normal-badge large-badge" :src="localUser.getUserIcon()"/>
        <div id="local-user-badge" class="badge central-badge audio-badge large-badge"
             :style="{'background-color':getUserColor(localUser)}"/>
      </div>

      <!-- Video Controls for local user -->
      <transition name="fade">
        <div class="control-bar" v-if="showControls">
          <md-button class="md-button" @click="toggleVideo">
            <font-awesome-icon :icon="videoIcon"></font-awesome-icon>
          </md-button>
          <md-button class="md-button" @click="toggleAudio">
            <font-awesome-icon :icon="audioIcon"></font-awesome-icon>
          </md-button>
          <!--
           <md-button class="md-button" @click="showSettingsDialogue">
            <font-awesome-icon icon="ellipsis-h"></font-awesome-icon>
          </md-button>
          -->
          <md-button class="md-button hang-up" @click="hangUp">
            <font-awesome-icon icon="phone"></font-awesome-icon>
          </md-button>
        </div>
      </transition>

    </div>

  </div>
</template>

<script>
import GridOff from 'vue-material-design-icons/GridOff.vue'
import VolumeHigh from 'vue-material-design-icons/VolumeHigh.vue'
import VolumeOff from 'vue-material-design-icons/VolumeOff.vue'

import {mapGetters, mapState} from "vuex";

const publisherDefaultBackground = require("@/assets/black_background_for_publisher.png");

export default {
  name: "MaximizedVideoPanel",
  components: {GridOff, VolumeHigh, VolumeOff},
  inject: ['toggleMaximizedVideoPanel', 'toggleLogin', 'toggleCommunication'],
  data: () => ({
    hoverVideo: false,
    enlargeSidebar: false,
    showAudioVideoSettings: false,
    layoutSizes: "", //"md-layout-item md-size-50",
    publisherAndSubscriberProperties: {
      width: "100%",
      height: "100%",
      fitMode: "cover",
      frameRate: 15,
      insertDefaultUI: true,
      resolution: "320x240",
      showControls: false,
      style: {
        audioLevelDisplayMode: "off",
        buttonDisplayMode: "off",
        nameDisplayMode: "off",
        backgroundImageURI: publisherDefaultBackground,
      },
    },
    publisher: null,
    properties: {
      hasAudio: true,
      hasVideo: true
    },
    movingAvg: null,
    subscribers: [], //objects with the following properties: id, subscriber, volume, hoverOverStream, hoverOverVolume, movingAvg
    showControls: false,
    help: false,  // used to re-render when subscriberPanelHover values are changed
  }),
  props: {
    toggleMaximizedVideoPanel: Function,
  },
  computed: {
    ...mapState({
      isAdjustingSettings: (state) => state.session.isAdjustingSettings,
      isOnboardingComplete: (state) => state.session.isOnboardingComplete,
      openTokStreams: (state) => state.session.openTokStreams,
      isOpenTokSessionConnnected: (state) => state.session.isOpenTokSessionConnnected,
      session: (state) => state.session.openTokSession,
    }),
    ...mapGetters([
      "isInSetup",
      "localUser",
      "users",
      "localUserID",
      "userProfile",
      "role",
      'isAudioOn',
      'isVideoOn',
      'getVideoDeviceId'
    ]),
    audioIcon: function () {
      return this.properties.hasAudio ? 'microphone' : 'microphone-slash';
    },
    videoIcon: function () {
      return this.properties.hasVideo ? 'video' : 'video-slash';
    },
    streamGrid() {
      let numberOfColumns = 1;
      let numberOfRows = 1;
      let necessaryStepsColumns = 1;
      let actualStepsColumns = 1;
      let necessaryStepsRows = 2;
      let actualStepsRows = 1;
      let userLength = this.streams.length + this.getUsersWithoutStream().length;
      for (let i = 1; i < userLength; i++) {
        if (actualStepsColumns === necessaryStepsColumns) {
          actualStepsColumns = 0;
          necessaryStepsColumns += 2;
          numberOfColumns++;
        }
        if (actualStepsRows === necessaryStepsRows) {
          actualStepsRows = 0;
          necessaryStepsRows += 2;
          numberOfRows++;
        }
        actualStepsRows++;
        actualStepsColumns++;
      }
      let streamGrid = [numberOfColumns];
      for (let i = 0; i < numberOfColumns; i++) {
        streamGrid[i] = [numberOfRows];
      }
      let countStreams = 0;
      let countUserWithoutStreams = 0;
      for (let i = 0; i < numberOfColumns; i++) {
        for (let j = 0; j < numberOfRows; j++) {
          if (this.streams[countStreams]) {
            streamGrid[i][j] = this.streams[countStreams];
            countStreams++;
          }else if(this.getUsersWithoutStream()[countUserWithoutStreams]){
            streamGrid[i][j] = this.getUsersWithoutStream()[countUserWithoutStreams];
            countUserWithoutStreams++;
          }
        }
      }
      return streamGrid;
    },
    localUserName() {
      if(this.localUser && this.localUser.getName()) return this.localUser.getName();
      return "";
    },
    usersWithoutStream() {
      let list = [];
      for (let a = 0; a < this.users.length; a++) {
        if (!this.hasUserStream(this.users[a].id) && this.users[a].id !== this.localUserID) {
          list.push(this.users[a]);
        }
      }
      return list;
    },
    streams() {
      return this.openTokStreams.filter((stream) => {
        return stream.videoType !== "screen";
      });
    }
  },
  mounted() {
    this.properties.hasAudio = this.isAudioOn;
    this.properties.hasVideo = this.isVideoOn;
    if (!this.isOnboardingComplete) {
      this.showAudioVideoSettings = true;
    }
    const self = this;
    this.$root.$on('publisherCompleted', (publisher) => {
      self.publisher = publisher;
      self.publisher.on('audioLevelUpdated', function (event) {
        self.handleAudioLevelUpdatedEventForPublisher(event);
      });
      self.session.on("signal:mute", function (event) {
        console.log(event);
        if (event.data === self.localUserID){
          console.log(self.publisher);
          self.publisher.publishAudio(false);
          self.$store.commit("setAudioOn", false);
        }
      });
    });
    this.$root.$on('subscriberConnected', (subscriber) => {
      let sameSubscriber = this.subscribers.filter((s) => {
        return s.id === subscriber.stream.connection.data.user_id
      });
      if (sameSubscriber.length < 1)
        this.$set(this.subscribers, this.subscribers.length, {
          id: subscriber.stream.connection.data.user_id,
          subscriber: subscriber,
          volume: subscriber.getAudioVolume(),
          hoverOverStream: false,
          hoverOverVolume: false,
          movingAvg: 0
        });
      self.addAudioLevelListenerForSubscriber(subscriber);
    });
    this.session.on('streamPropertyChanged', (event) => {
      this.handleStreamPropertyChangedEvent(event);
    });
  },
  destroyed() {
    const self = this;
    this.$root.$off('publisherCompleted', (publisher) => {
      self.publisher = publisher;
      self.addAudioLevelListenerForPublisher();
    });
    this.$root.$off('subscriberConnected', (subscriber) => {
      self.subscriberMovingAvg.set(subscriber.stream.connection.data.user_id, 0);
      self.addAudioLevelListenerForSubscriber(subscriber);
    });
    if(this.publisher) this.publisher.off();
    if(this.session) this.session.off('streamPropertyChanged');
  },
  methods: {
    getUsersWithoutStream() {
      let list = [];
      for (let a = 0; a < this.users.length; a++) {
        if (!this.hasUserStream(this.users[a].id) && this.users[a].id !== this.localUserID) {
          list.push(this.users[a]);
        }
      }
      return list;
    },
    createElementId(prefix, id) {
      return (prefix + "_" + id);
    },
    handleStreamPropertyChangedEvent: function (event) {
      // Is it the publisher's stream?
      if (this.publisher && event.stream && event.stream.id === this.publisher.streamId) {
        try {
          this.properties[event.changedProperty] = event.newValue;
        } catch (e) {
          console.error(e);
        }
      }
    },
    handleAudioLevelUpdatedEventForPublisher: function (event) {
      const self = this;
      if (document.getElementById("local-user-badge") || document.getElementById("local-user-small-audio-badge")) {
        let badge;
        if (document.getElementById("local-user-badge")) {
          badge = document.getElementById("local-user-badge");
        } else {
          badge = document.getElementById("local-user-small-audio-badge");
        }

        if (self.movingAvg === null || self.movingAvg <= event.audioLevel) {
          self.movingAvg = event.audioLevel;
        } else {
          self.movingAvg = 0.7 * self.movingAvg + 0.3 * event.audioLevel;
        }

        // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
        let logLevel = (Math.log(self.movingAvg) / Math.LN10) / 1.5 + 1;
        if (document.getElementById("local-user-badge")) {
          logLevel = Math.min(Math.max(logLevel, 0), 1) + 1;
        } else {
          logLevel = Math.min(Math.max(logLevel, 0), 1) + 0.5;
        }
        badge.style.transform = "scale(" + logLevel + ", " + logLevel + ")";
      }
    },
    getSubscriberWithID(id) {
        return this.subscribers.filter((s) => {
          return s.id === id
        })[0];
      },
      setMovingAvgForSubscriber(id, avg) {
        let sub = this.getSubscriberWithID(id);
        if (sub) sub.movingAvg = avg;
      },
      getMovingAvgForSubscriber(id) {
        let sub = this.getSubscriberWithID(id);
        if (sub) return sub.movingAvg;
        return undefined;
      },
      setVolumeOfSubscriber(id, newState) {
        let s = this.subscribers.filter((s) => {
          return s.id === id
        })[0];
        if (s && newState) {
          if (newState === "mute") s.subscriber.subscribeToAudio(false);
          else s.subscriber.subscribeToAudio(true);
        } else {
          if (s && document.getElementsByClassName("subscriber-volume-slider")[0]) {
            let value = Number(document.getElementsByClassName("subscriber-volume-slider")[0].value);
            s.subscriber.setAudioVolume(value);
          }
        }
        this.toggleReRenderHelp();
      },
      getVolumeOfSubscriber(id) {
        let s = this.subscribers.filter((s) => {
          return s.id === id
        })[0];
        if (s) return s.subscriber.getAudioVolume();
        return 0;
      },
      handleHoverOverVolume(id, isHovering) {
        let s = this.subscribers.filter((s) => {
          return s.id === id
        })[0];
        if (s) s.subscriber.hoverOverVolume = isHovering;
        this.toggleReRenderHelp();
      },
      // returns true if the user hovers over the volume button (which mutes or unmutes a subscriber)
      getHoverStateOfVolume(id) {
        let s = this.subscribers.filter((s) => {
          return s.id === id
        })[0];
        if (s) return s.subscriber.hoverOverVolume;
        return false;
      },
      // returns true if the user hovers over a stream panel
      getHoverStateOfStream(id) {
        let s = this.subscribers.filter((s) => {
          return s.id === id
        })[0];
        if (s) return s.subscriber.hoverOverStream;
        return false;
      },
      handleHoverOverStream(id, isHovering) {
        let s = this.subscribers.filter((s) => {
          return s.id === id
        })[0];
        if (s) s.subscriber.hoverOverStream = isHovering;
        this.toggleReRenderHelp();
      },
      // needed to start a re-render because the variables of the objects in the subscribers list aren't reactive
      toggleReRenderHelp() {
        this.help = false;
        this.help = true;
      },
      addAudioLevelListenerForSubscriber(subscriber) {
        const self = this;
        subscriber.on('audioLevelUpdated', function (event) {
          if (document.getElementById("badge_" + subscriber.stream.connection.data.user_id) || document.getElementById("audio_" + subscriber.stream.connection.data.user_id)) {
            let movingAvg = self.getMovingAvgForSubscriber(subscriber.stream.connection.data.user_id);
            let badge;
            if (document.getElementById("badge_" + subscriber.stream.connection.data.user_id)) {
              badge = document.getElementById("badge_" + subscriber.stream.connection.data.user_id);
            } else {
              badge = document.getElementById("audio_" + subscriber.stream.connection.data.user_id);
            }

            if (movingAvg === null || movingAvg <= event.audioLevel) {
              movingAvg = event.audioLevel;
            } else {
              movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
            }

            // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
            let logLevel = (Math.log(movingAvg) / Math.LN10) / 1.5 + 1;
            if (document.getElementById("local-user-badge")) {
              logLevel = Math.min(Math.max(logLevel, 0), 1) + 1;
            } else {
              logLevel = Math.min(Math.max(logLevel, 0), 1) + 0.5;
            }
            self.setMovingAvgForSubscriber(subscriber.stream.connection.data.user_id, movingAvg);
            badge.style.transform = "scale(" + logLevel + ", " + logLevel + ")";
          }
        });
      },
      addAudioLevelListenerForPublisher() {
        const self = this;
        this.publisher.on('audioLevelUpdated', function (event) {
          if (document.getElementById("local-user-badge") || document.getElementById("local-user-small-audio-badge")) {
            let badge;
            if (document.getElementById("local-user-badge")) {
              badge = document.getElementById("local-user-badge");
            } else {
              badge = document.getElementById("local-user-small-audio-badge");
            }

            if (self.movingAvg === null || self.movingAvg <= event.audioLevel) {
              self.movingAvg = event.audioLevel;
            } else {
              self.movingAvg = 0.7 * self.movingAvg + 0.3 * event.audioLevel;
            }

            // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
            let logLevel = (Math.log(self.movingAvg) / Math.LN10) / 1.5 + 1;
            if (document.getElementById("local-user-badge")) {
              logLevel = Math.min(Math.max(logLevel, 0), 1) + 1;
            } else {
              logLevel = Math.min(Math.max(logLevel, 0), 1) + 0.5;
            }
            badge.style.transform = "scale(" + logLevel + ", " + logLevel + ")";
          }
        });
      },
      getUserColor(user) {
        return ("#" + user.getColor().substring(2, 8));
      },
      hasUserStream(userId) {
        for (let a = 0; a < this.openTokStreams.length; a++) {
          if (this.openTokStreams[a].connection.data.user_id === userId) {
            return true;
          }
        }
        return false;
      },
      getUserOfId(id) {
        for (let a = 0; a < this.users.length; a++) {
          if (this.users[a].id === id) return this.users[a]
        }
        return undefined;
      },
      isUserWithIDModerator(userID) {
        let user = this.users.filter((x) => x.getID() === userID);
        if (user.length > 0) {
          return user[0].getRole() === "moderator";
        }
        return false;
      },
      getUserName(userID) {
        let user = this.users.filter((x) => x.getID() === userID);
        if (user.length > 0 && user[0].getName()) {
          return user[0].getName();
        }
        return "";
      },
      localUserIsModerator() {
        return (this.localUser && this.localUser.getRole() === "moderator");
      },
      toggleAudio: function () {
        if (this.publisher) {
          console.log(`Toggle audio on publisher id: ${this.publisher.id}`);
          this.publisher.publishAudio(!this.properties.hasAudio);
          this.$store.commit('setAudioOn', !this.properties.hasAudio);
        }
      },
      toggleVideo: function () {
        if (this.publisher) {
          console.log(`Toggle video on publisher id: ${this.publisher.id}`);
          this.publisher.publishVideo(!this.properties.hasVideo);
          this.$store.commit('setVideoOn', !this.properties.hasVideo);
        }
      },
      /*
    showSettingsDialogue: function () {
      this.$store.commit('setShowAudioVideoSettings', true);
    },
     */
      hangUp: function () {
        this.toggleMaximizedVideoPanel();
        this.toggleLogin();
        this.toggleCommunication();
        let logoff = null;
        if (this.role === 'moderator') {
          logoff = this.$store.dispatch('logOffFromCms');
        } else {
          logoff = this.$store.dispatch('disconnectOpenTok');
        }
        console.log(`Hanging up call for role ${this.role}`);
        logoff
            .then(() => {
              return this.$store.dispatch('initialize');
            })
            .then(() => {
              console.log('Call hung up');
            })
            .catch((e) => {
              console.error(e);
            });
        },
  },
}

</script>

<style scoped>
.maximized-video-panel {
  position: absolute;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(21, 21, 21, 0.9);
  color: white;
  z-index: 10;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

@-moz-document url-prefix() {
  .maximized-video-panel {
    background: rgba(55, 55, 55, 0.95);
  }
}

.exit-button {
  position: absolute;
  right: 0;
  margin: 30px;
}

.maximized-video-panel .active {
  background-color: var(--primaryColor);
}

.maximized-video-panel .name-badge {
  position: absolute;
  margin: 5px;
  z-index: 2;
}

.moderator {
  border: 2px solid var(--primaryColor);
  padding: 2px;
}

.local-user-stream {
  position: absolute;
  background-color: black;
  height: 160px;
  width: 280px;
  padding: 2px;
  right: 0;
  bottom: 0;
}

.local-user-stream.visitor {
  border-left: 1px solid white;
  border-top: 1px solid white;
}

.video-streams {
  height: 100%;
  width: 100%;
}

.stream-container {
  height: 100%;
  width: 100%;
  display: flex;
}

.video-streams-column {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
}

.stream-panel {
  position: relative;
  width: 100%;
  height: 100%;
  flex: 1 1 0px;
  background-color: black;
}

.maximized-video-panel ::-webkit-scrollbar {
  height: 13px;
}

.maximized-video-panel ::-webkit-scrollbar-track {
  background: rgb(49, 49, 49);
  border-radius: 10px;
}

.maximized-video-panel ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  border: 1px solid rgb(27, 27, 27);
  background: rgb(111, 111, 111);
}

.panels-without-stream {
  display: flex;
  justify-content: flex-end;
  width: 80%;
  overflow-x: auto;
}

.panels-without-stream .panel {
  position: relative;
  width: 25%;
  height: 100%;
  background-color: black;
}

#publisher-container * {
  min-height: calc(100% - 4px);
  min-width: calc(100% - 4px);
  max-height: calc(100% - 4px);
  max-width: calc(100% - 4px);
  position: absolute;
  top: 0;
}

.maximized-video-panel .badge-container {
  display: flex;
  align-items: flex-start;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
}

.badge {
  border-radius: 100%;
}

.central-badge {
  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
}

.normal-badge {
  z-index: 9;
}

.audio-badge {
  position: absolute;
  opacity: 0.6;
  z-index: 8 !important;
}

.large-badge {
  height: 30px;
  max-height: 30px;
  width: 30px;
  min-width: 30px;
}

.small-badge {
  z-index: 9;
  border-radius: 100%;
  height: 22px;
  max-height: 22px;
  width: 22px;
  min-width: 22px;
  margin-right: 5px;
}

.control-bar {
  position: absolute;
  display: flex;
  justify-content: center;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.7);
  bottom: 0;
  right: 0;
  width: 100%;
}

.control-bar .md-button {
  width: 25%;
  min-width: 0;
  margin: 0;
  border-radius: 0;
}

.subscriber-control-bar-container {
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
}

.subscriber-control-bar {
  justify-content: flex-start;
  height: 40px;
}

.subscriber-control-bar .md-button {
  max-width: 50px;
  height: 40px;
  min-height: calc(100% - 10px);
  margin: 5px 0;
}

/* Source for input range element customization: https://css-tricks.com/styling-cross-browser-compatible-range-inputs-css/ */

/*** Start volume slider ***/

input[type=range] {
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  width: 90%; /* Specific width is required for Firefox. */
  background: transparent; /* Otherwise white in Chrome */
}

input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: 1px solid #000000;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
  margin-top: -14px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
}

input[type=range]:focus {
  outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
}

input[type=range]::-ms-track {
  width: 90%;
  cursor: pointer;
  height: 8.4px;
  border-width: 16px 0;

  /* Hides the slider so custom styles can be added */
  background: transparent;
  border-color: transparent;
  color: transparent;
}

/* All the same stuff for Firefox */
input[type=range]::-moz-range-thumb {
  border: 1px solid #000000;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 90%;
  height: 8.4px;
  cursor: pointer;
  background: var(--primaryColor);
  border-radius: 1.3px;
  border: 0.2px solid #010101;
}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: var(--primaryColor);
}

input[type=range]::-moz-range-track {
  width: 90%;
  height: 8.4px;
  cursor: pointer;
  background: var(--primaryColor);
  border-radius: 1.3px;
  border: 0.2px solid #010101;
}

input[type=range]::-ms-fill-lower {
  background: var(--primaryColor);
  border: 0.2px solid #010101;
  border-radius: 2.6px;
}

input[type=range]::-ms-fill-upper {
  background: var(--primaryColor);
  border: 0.2px solid #010101;
  border-radius: 2.6px;
}

input[type=range]::-ms-thumb {
  border: 1px solid #000000;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
}

input[type=range]:focus::-ms-fill-lower {
  background: var(--primaryColor);
}

input[type=range]:focus::-ms-fill-upper {
  background: var(--primaryColor);
}

/*** End volume slider ***/

.volume-slider-container {
  display: flex;
  align-content: center;
  transform: rotate(-90deg);
  max-width: 150px;
  width: 150px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 0px 0px 6px 0px;
  -moz-border-radius: 0px 0px 6px 0px;

  position: absolute;
  justify-content: center;
  z-index: 2;
  left: -50px;
  bottom: 90px;
}

.volume-container {
  width: 50px;
}

.volume-container .md-button {
  width: 50px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fa-video {
  color: white;
}

.fa-video-slash {
  color: white;
}

.fa-microphone {
  color: white;
}

.fa-microphone-slash {
  color: white;
}

.fa-ellipsis-h {
  color: white;
}

.fa-phone {
  color: red;
  font-weight: bold;
}
</style>